import tw from 'tailwind-styled-components'

const FooterContainer = tw.footer`
h-[72px]
md:bg-white
bg-[#F0F1F7]
w-full
px-8
flex 
items-center
justify-between
`
export {FooterContainer}